/*
** 
** 封装请求方法 | Encapsulating the request method
** 
**/

//axios数据请求
import config from './config.js'
import axios from 'axios'
const request = function({that,api,method,headers,data,timeout,success,fail,loading}){
    if(loading){that.$dialog.loading.open()}
    axios({
        // `url` 是用于请求的服务器 URL
        url: api ? api : null,

        // `method` 是创建请求时使用的方法
        method: method ? method : 'POST',

        // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
        // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
        baseURL: config.url_prefix,

        // `headers` 是即将被发送的自定义请求头
        headers: headers ? headers : {
            'X-Requested-With': 'XMLHttpRequest',
            'accesstoken': that.$storage.get('accesstoken')?that.$storage.get('accesstoken'): ''
        },

        // `data` 是作为请求主体被发送的数据
        // 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
        // 在没有设置 `transformRequest` 时，必须是以下类型之一：
        // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
        // - 浏览器专属：FormData, File, Blob
        // - Node 专属： Stream
        data: data ? data : null,

            // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
        // 如果请求话费了超过 `timeout` 的时间，请求将被中断
        timeout: timeout ? timeout : 0,

        //// `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
        responseType: 'json', // 默认的

    }).then( res => {
        console.log('请求成功',res)
        //console.log('请求参数',data)
        switch(parseInt(res.data.code)){
            case 200://请求成功
                success(res.data)
                break;
            case 500://请求失败
                that.$dialog.toast({
                    mes: res.data.msg,
                    icon: 'none',
                })
                // that.$dialog.notify({ mes: res.data.msg })
                if(fail) { fail(res.data) }
                break;
            case 40029://获取用户登陆状态失败
                that.$dialog.confirm({ 
                    title: '请登录',
                    mes: res.data.msg, 
                    opts: () => {
                        that.$storage.remove('accesstoken')
                        
                        that.$router.push({path:'/Protestantism'})
                    }
                })
                break;
        }
        if(loading){that.$dialog.loading.close()}
    }).catch( err => {
        //console.log('请求失败：',err)
        if (err.response) {
            console.log('请求失败(1)：',err.response.data)
            that.$dialog.toast({ mes: err.response.data.msg })
        } else if (err.request) {
            console.log('请求失败(2)：',err.request)
            that.$dialog.toast({ mes: err.request })
        } else {
            console.log('请求失败(3)：', err.message)
            that.$dialog.toast({ mes: err.message })
        }
        if(loading){that.$dialog.loading.close()}
    });
}


export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js